import { BookHeartIcon } from './BookHeartIcon';

/**
 * author: Austin Andrews
 * id 4A830C97-1A09-495F-91A5-8F02571C54C6
 * name book-heart
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-heart.svg
 * tags
 */
export const BookLoveIcon = BookHeartIcon;
export default BookLoveIcon